import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchContactProfileFields } from "../redux/Slice/Settings/contactProfileFieldsSlice";

// Built-in contact fields. Values are contact property names; custom Contact Profile fields use
// "custom:<fieldId>". Both are resolved server-side by utils/contactFieldValue.js.
const CORE_CONTACT_FIELD_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "phoneNumberID", label: "Phone number" },
  { value: "email", label: "Email" },
  { value: "businessName", label: "Business name" },
];

// Set Variable nodes saved before this list grew stored the display label instead.
const LEGACY_VALUES = { Name: "name", "Phone number": "phoneNumberID", Phone: "phoneNumberID" };

export const normalizeContactFieldValue = (value) => LEGACY_VALUES[value] || value || "";

/**
 * Every contact field a "From contact" source can read: the built-in ones plus the workspace's
 * custom Contact Profile fields. Loads the custom fields once if they aren't in the store yet.
 * @param {string} [workspaceId] - defaults to the current workspace
 * @returns {{value:string,label:string}[]}
 */
export default function useContactFieldOptions(workspaceId) {
  const dispatch = useDispatch();
  const currentWorkspaceId = useSelector((state) => state.workspace?.currentWorkspace?._id);
  const { items, loading } = useSelector((state) => state.contactProfileFields) || {};
  const effectiveWorkspaceId = workspaceId || currentWorkspaceId;
  const hasItems = Array.isArray(items) && items.length > 0;

  useEffect(() => {
    if (effectiveWorkspaceId && !hasItems && !loading) dispatch(fetchContactProfileFields(effectiveWorkspaceId));
  }, [effectiveWorkspaceId, hasItems, loading, dispatch]);

  return useMemo(
    () => [
      ...CORE_CONTACT_FIELD_OPTIONS,
      ...(Array.isArray(items) ? items : []).map((f) => ({ value: `custom:${f._id}`, label: f.name })),
    ],
    [items]
  );
}
